import { types } from "../types/typesAuth";

const initialState = {
  activeUsuario: null,
  activeEmpleado: null,
  usuarios: [],
  checking: false,
  checked: false, // indica que ya se hizo la comprobación inicial
  visibleFormUsuario: false,
  paths: [],
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.authLogin:
      return {
        ...state,
        activeUsuario: action.payload,
      };
    case types.authUsuarioSetPaths:
      return {
        ...state,
        paths: action.payload,
      };
    case types.authUsuarioChecking:
      return {
        ...state,
        checking: action.payload,
      };
    case types.authUsuarioLogout:
      return {
        ...initialState,
      };
    case types.authUsuarioChecked:
      return {
        ...state,
        checked: true,
      };
    case types.authUsuarioLoginSetActive:
      return {
        ...state,
        activeUsuario: action.payload,
      };
    case types.authEmpleadoSetActive:
      return {
        ...state,
        activeEmpleado: action.payload,
      };

    default:
      return state;
  }
};
